import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteFetchCluster } from "../../../data/usecases/brick-management/remote-fetch-cluster";
import { ClusterType } from "../../../domain/models/brick-management-report/brick-management-data";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchClusterInterface {
  clusterData: ClusterType[];
  fetchCluster: Function;
}

const initialValue = {
  clusterData: [],
};
const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchClusterSlice: StateCreator<FetchClusterInterface> = (
  set
) => ({
  ...initialValue,
  fetchCluster: async (code: string) => {
 const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
 const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchCluster = new RemoteFetchCluster(
      `${BASE_URL}${Endpoints.FETCH_CLUSTER_MASTER}`,
      axiosHttpClient
    );
    const payload = { district_code: code };
    let result = await remoteFetchCluster.fetch(payload);
    if (result) {
      set(() => ({ clusterData: result }));
    }
  },
});
